import styled from '@emotion/styled'
import { createPropFilter, WebLink, WebLinkProps } from '@news-mono/web-common'
import { CardText } from '../../../../cards/CardText/CardText'
import { breakpoint, calcRem, fonts, metrics } from '../../../../__styling'

type LayoutTypes = 'landscape' | 'portrait'

interface Layout {
    layout: LayoutTypes
}

export const StyledEntertainmentInlineCardContainer = styled('div')<Layout>(
    ({ layout }) => [
        {
            display: layout === 'portrait' ? 'grid' : 'block',
            gridTemplateColumns: '1fr',
            gridGap: `${metrics.sevennews.margins.sm}px ${metrics.sevennews.margins.gridGap}px`,

            [breakpoint('xxs')]: {
                gridTemplateColumns: '1fr 1fr',
            },
        },
    ],
)

interface StyledEntertainmentCardProps {
    layout: LayoutTypes
}

export const StyledEntertainmentCard = styled(WebLink, {
    shouldForwardProp: createPropFilter<WebLinkProps>()(['layout']),
})<StyledEntertainmentCardProps>(({ layout, theme }) => [
    {
        fontFamily: fonts.sevennews.sansSerifCond,
        textDecoration: 'none',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: `1px 1px 6px 0 rgba(0,0,0,0.16)`,
        background: theme.colors.background.primary,
        padding: calcRem(15),
        display: 'flex',
        border: '2px solid transparent',
        transition:
            'border 0.250s cubic-bezier(0.55, 0, 0.1, 1),background 0.250s cubic-bezier(0.55, 0, 0.1, 1)',
        ['&:hover']: {
            background: 'rgba(192, 169, 246, 0.2)',
        },
        ['&:focus']: {
            border: `2px solid ${theme.colors.borders.tertiary}`,
        },
    },

    layout === 'landscape' && {
        width: `100%`,
    },
])

export const StyledEntertainmentCardText = styled(CardText)({
    fontWeight: 'bold',
    [`& span`]: {
        color: '#333333',
    },
})

export const StyledEntertainmentCardIcon = styled('img')({
    alignSelf: 'flex-end',
    marginLeft: calcRem(10),
})
